<template>
  <div class="p-2 text-left bg-white fw-bold rounded border border-white">
    <div class="d-flex justify-content-between">
      <div class="mt-0">
        <div class="text-sm-secondary">
          {{ phone }}<br>
          {{ email }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactCell',
  props: ['phone', 'email']
}
</script>

<style scoped>
.text-left {
  text-align: left;
}

.text-sm-secondary {
  font-size: .6rem;
}
</style>
